export const TEST_STANDARDS_START = 'test-standards/test-standards-start';
export const TEST_STANDARDS_SUCCESS = 'test-standards/test-standards-success';
export const TEST_STANDARDS_ERROR = 'test-standards/test-standards-error';
export const TEST_STANDARDS_UPDATE_SUCCESS =
  'test-standards/test-standards-update-success';
